export default {

    props: {

        carrier_preselect: {

            type     : Number,
            default  : null,
            required : false
        }
    },

    data(){

        return {

        }
    },

    computed: {

        carrierId(){

            return this.carrier_preselect || this.carrier;
        },
        parentId(){

            return this.carrier_preselect ? '' : this.parent_carrier;
        },
    },

    methods: {

    },

    watch: {

    },

    async created(){

    }
}